import { Injectable } from '@angular/core';
import { TrackingEvent } from '../../../../../cross-team-shared/event-tracking/event-utils';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';
import { EventTrackingOptions } from '../../../../../team-apis/core/event-tracking';
import { UndoService } from '../toolbars/static-toolbar/undo.service';

@Injectable()
export class PushAndTrackService {
  constructor(
    private eventTrackingService: EventTrackingService,
    private undoService: UndoService,
  ) {}

  pushAndTrack(event: TrackingEvent, options?: EventTrackingOptions) {
    if (this.undoService.pushCurrentState().hasTrackedChanges) {
      this.eventTrackingService.track(event, options);
    }
  }
}
